// Framework and third-party non-ui
import React, { useState } from 'react';

// Third-party components (buttons, icons, etc.)
import { makeStyles } from '@material-ui/core/styles';

// CSS
// import './FilterSelect.css';

const Any = ({ selectedHandler }) => {
  const useStyles = makeStyles((theme) => ({
    any: {
      fontFamily: 'Open Sans',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '.25px',
      color: '#4D7343',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }));
  const classes = useStyles();

  const anyHandleKeyUp = (e) => {
    if (e.keyCode === 13) {
      selectedHandler();
    }
  };

  return (
    <>
      <div
        className={classes.any}
        onClick={selectedHandler}
        tabIndex='0'
        onKeyUp={(e) => {
          anyHandleKeyUp(e);
        }}
      >
        Any
      </div>
    </>
  );
};

export default Any;
